import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
const LCP_IMAGE = 'https://cdn.magicpatterns.com/uploads/w8iQe91H85AMFxcthHZQ5z/Diseno-sin-titulo-_34_.webp';
const GOOGLE_FONTS_URL = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=optional';
function loadMetaPixel() {
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  w.fbq('init', '1181648490064668');
  w.fbq('track', 'PageView');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=1181648490064668&ev=PageView&noscript=1';
  document.body.appendChild(img);
}
export function App() {
  useEffect(() => {
    // Preconnect to critical origins only (max 2-3)
    const preconnects = [{
      href: 'https://fonts.gstatic.com',
      crossOrigin: 'anonymous'
    }, {
      href: 'https://cdn.magicpatterns.com',
      crossOrigin: 'anonymous'
    }];
    preconnects.forEach(({
      href,
      crossOrigin
    }) => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      if (crossOrigin) link.crossOrigin = crossOrigin;
      document.head.appendChild(link);
    });
    // Preload LCP image for faster discovery
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.as = 'image';
    preload.href = LCP_IMAGE;
    document.head.appendChild(preload);
    // Load Google Fonts asynchronously (non-render-blocking)
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = GOOGLE_FONTS_URL;
    fontLink.media = 'print';
    fontLink.onload = function () {
      fontLink.media = 'all';
    };
    document.head.appendChild(fontLink);
    // Defer Meta Pixel — load when browser is idle to reduce main thread work
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadMetaPixel, {
        timeout: 3500
      });
    } else {
      setTimeout(loadMetaPixel, 2000);
    }
  }, []);
  return <LandingPage data-id="element-0" />;
}